import React, { Fragment } from 'react';
import { H3, H4, P, Image } from '../../../../../../AbstractElements';
import { InvoiceHash, IssuedJan, PaymentDue } from '../../../../../../Constant';
import { Col, Media, Row } from 'reactstrap';
import logo from '../../../../../../assets/images/logo/logo.png';
import { useLocation } from 'react-router';

const InvoiceHeader = () => {

  const location = useLocation()

  const {rowData, data} = location.state || {};

  console.warn(rowData)

  // const createdDate = new Date(rowData.created_at);
  //       const formattedDate = createdDate.toISOString().split("T")[0];
  return (
    <Fragment>
      <div className='d-flex justify-content-between'>
      {/* <Row className='invo-header'>
        <Col sm='6'> */}
          <Media>
            <div className='media-left'>
              <Image attrImage={{ className: 'media-object img-60', src: logo, alt: '' }} />
            </div>
            <Media body className='m-l-20 text-right'>
              <H4 attrH4={{ className: 'media-heading f-w-600' }}>Witte</H4>
              <P>
                witte@macincode.in
                <br />
                <span className='digits'>{'289-335-6503'}</span>
              </P>
            </Media>
          </Media>
        {/* </Col>
        <Col sm='6'> */}
          <div className='text-md-end'>
          {/* <div className='text-md-end  text-xs-center'> */}
            <H3>
              {rowData? "Prescription" :InvoiceHash}
              {/* <span className='digits counter'>1069</span> */}
            </H3>
            <P>
              {/* {IssuedJan} */} {"Issued: "}
              <span className='digits'>{rowData.date}</span>
              <br />
              {/* {PaymentDue} <span className='digits'> 27, 2022</span> */}
            </P>
          </div>
        {/* </Col>
      </Row> */}
      </div>
      <hr />
    </Fragment>
  );
};
export default InvoiceHeader;
